import { StreetViewInteractor, StreetViewRequest, StreetViewStructRequest } from "../../Coordinator/StreetView/StreetViewInteractor";

export class StreetViewViewModel {
	private interactor: StreetViewInteractor;

	constructor() {
		this.interactor = new StreetViewInteractor();
	}

	public fetchImport(formData:any): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.fetchImport(formData).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchData(page:number): PromiseLike<any> {
		return new Promise((res, rej) => {
			this.interactor.fetchData(page).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}